/** One PGS inbound per PO — detail lines repeat the same pgsInboundID per SKU. */

export function uniquePgsInboundIds(ids: Array<string | number | null | undefined>): string[] {
	const seen = new Set<string>();
	const out: string[] = [];
	for (const raw of ids) {
		if (raw == null || raw === '') { continue; }
		const s = String(raw);
		if (!seen.has(s)) {
			seen.add(s);
			out.push(s);
		}
	}
	return out;
}

export function collectPgsInboundIdsFromPayload(data: any): string[] {
	if (!data || typeof data !== 'object') { return []; }
	const inner = data.Data ?? data.data ?? data;
	const details = inner?.DetailsLoaded ?? inner?.detailsLoaded ?? [];
	if (!Array.isArray(details)) { return []; }
	const raw: string[] = [];
	for (const d of details) {
		const id = d?.pgsInboundID ?? d?.pgsinboundid;
		if (id != null && id !== '') {
			raw.push(String(id));
		}
	}
	return uniquePgsInboundIds(raw);
}

export function formatPgsInboundDetail(ids: string[]): string {
	if (!ids.length) { return ''; }
	if (ids.length === 1) { return `PGS Inbound ${ids[0]}`; }
	return `PGS Inbounds ${ids.join(', ')}`;
}

export function formatTpl3plInboundSummary(raw: any): string {
	if (raw == null || raw === '') { return ''; }
	const data: any = typeof raw === 'string'
		? (() => { try { return JSON.parse(raw); } catch { return null; } })()
		: raw;
	if (!data || typeof data !== 'object') { return ''; }
	const inner = data.Data ?? data.data ?? data;
	const ids = collectPgsInboundIdsFromPayload(data);
	const poEcho = inner?.purchaseOrderNo ?? inner?.purchaseorderno ?? '';
	if (ids.length) {
		const idPart = ids.length === 1 ? `PGS Inbound ID ${ids[0]}` : `PGS Inbound IDs ${ids.join(', ')}`;
		return poEcho ? `3PL PO: ${poEcho} · ${idPart}` : idPart;
	}
	return poEcho ? `3PL PO ref: ${poEcho}` : '';
}
